import { xenvActionFactory } from '../xenv';
import { alimpPay, alipayPay, wxmpPay, weixinPay, h5Pay, esappPay, passengerPay, kfpassengerPay, yxwxmpPay, hitchappPay, hywxmpPay, qjwxmpPay, sfcwxmpPay } from '../platform/xenv';
const xenvPayConfig = {
    'alipay': alipayPay,
    'alimp': alimpPay,
    'h5': h5Pay,
    'weixin': weixinPay,
    'wxmp': wxmpPay,
    'hywxmp': hywxmpPay,
    'passenger': passengerPay,
    'kfpassenger': kfpassengerPay,
    'yxwxmp': yxwxmpPay,
    'esapp': esappPay,
    'hitchapp': hitchappPay,
    'qjwxmp': qjwxmpPay,
    'sfcwxmp': sfcwxmpPay
};
function pay(opt) {
    const fn = xenvActionFactory('pay', xenvPayConfig);
    return fn(opt);
}
export { pay };
